import { Link, Outlet, useLocation } from 'react-router-dom';
import { User, Settings, ShieldCheck } from 'lucide-react';

export function ProfileLayout() {
  const location = useLocation();

  const tabs = [
    { name: 'Minha Conta', path: '/perfil/conta', icon: User },
    { name: 'Preferências', path: '/perfil/preferencias', icon: Settings },
    { name: 'Privacidade (LGPD)', path: '/perfil/privacidade', icon: ShieldCheck },
  ];

  return (
    <div className="space-y-8 animate-fade-in">
      <div className="space-y-2">
        <span className="inline-flex items-center gap-2 rounded-full glass px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-accent">
          <User className="h-3 w-3" />
          <span>Perfil do usuário</span>
        </span>
        <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight text-white">
          Configurações de perfil
        </h1>
        <p className="text-sm text-ink-muted max-w-2xl">
          Gerencie seus dados pessoais, preferências de exibição e direitos de privacidade
          previstos pela LGPD.
        </p>
      </div>

      <div className="flex flex-col lg:flex-row gap-8">
        <aside className="lg:w-64 shrink-0">
          <nav className="flex flex-row gap-2 overflow-x-auto pb-2 lg:flex-col lg:overflow-x-visible lg:space-y-1 lg:pb-0">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = location.pathname === tab.path;
              return (
                <Link
                  key={tab.name}
                  to={tab.path}
                  className={`flex shrink-0 items-center gap-3 rounded-xl px-4 py-2.5 text-xs font-bold transition-all duration-fast ${
                    isActive
                      ? 'bg-accent/15 text-accent hairline shadow-glow-xs'
                      : 'text-ink-muted hover:bg-white/[0.04] hover:text-ink border border-transparent'
                  }`}
                >
                  <Icon className="h-4 w-4 shrink-0" />
                  <span>{tab.name}</span>
                </Link>
              );
            })}
          </nav>
        </aside>

        <section className="flex-grow rounded-2xl card-premium p-6 lg:p-8">
          <Outlet />
        </section>
      </div>
    </div>
  );
}
